'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_math_Ordered__$greater__O__Z($thiz, that) {
  return ($thiz.ic(that) > 0);
}
export { $f_s_math_Ordered__$greater__O__Z as $f_s_math_Ordered__$greater__O__Z };
